// extracted by mini-css-extract-plugin
export var alt = "FeaturedDestinations-module--alt--9d5a2";
export var cityContainer = "FeaturedDestinations-module--cityContainer--a9205";
export var container = "FeaturedDestinations-module--container--0e87c";
export var description = "FeaturedDestinations-module--description--b071d";
export var desktopOnly = "FeaturedDestinations-module--desktopOnly--688a9";
export var destinationContainer = "FeaturedDestinations-module--destinationContainer--e2656";
export var destinationLink = "FeaturedDestinations-module--destinationLink--8fa0a";
export var findLink = "FeaturedDestinations-module--find-link--201b4";
export var findYourDestination = "FeaturedDestinations-module--findYourDestination--ac986";
export var main = "FeaturedDestinations-module--main--fbc47";
export var mobileOnly = "FeaturedDestinations-module--mobileOnly--5af41";
export var subTitle = "FeaturedDestinations-module--subTitle--a82d8";
export var textLeft = "FeaturedDestinations-module--textLeft--187e0";
export var textWhite = "FeaturedDestinations-module--text-white--b6626";
export var title = "FeaturedDestinations-module--title--6fe30";
export var visuallyHidden = "FeaturedDestinations-module--visuallyHidden--13e29";